import type { HistoryEvent } from "@/data/interventionHistoryRepository";

/** Historically, some saves converted absent display fields to empty strings.
 * Those are serialization changes, not edits made by an administrator. */
function blank(value: unknown): boolean {
  return (
    value == null ||
    (typeof value === "string" && value.trim() === "") ||
    (Array.isArray(value) && value.length === 0)
  );
}

export function meaningfulHistoryChanges(
  event: HistoryEvent,
): HistoryEvent["changes"] {
  if (event.action !== "updated") return event.changes;
  return Object.fromEntries(
    Object.entries(event.changes).filter(([key, change]) => {
      if (key === "status" || key === "location" || key === "is_active") return true;
      if (
        typeof change.old_length === "number" &&
        typeof change.new_length === "number" &&
        change.old_length === 0 &&
        change.new_length === 0
      ) return false;
      if (
        !change.changed &&
        Object.prototype.hasOwnProperty.call(change, "old") &&
        Object.prototype.hasOwnProperty.call(change, "new") &&
        blank(change.old) &&
        blank(change.new)
      ) return false;
      return true;
    }),
  );
}

/** Filter for presentation only. Existing audit rows remain untouched. */
export function meaningfulHistoryEvents(events: HistoryEvent[]): HistoryEvent[] {
  return events
    .map((event) => ({ ...event, changes: meaningfulHistoryChanges(event) }))
    .filter((event) => event.action !== "updated" || Object.keys(event.changes).length > 0);
}
